import { schema } from "normalizr";
import { arrayOfAttachments } from "./schema.attachments.jsx";
import { arrayOfReactions } from "./schema.reactions.jsx";
import { task } from "./schema.tasks.jsx";

const comment = new schema.Entity(`comments`);
const arrayOfComments = [comment];

comment.define({
  attachments: arrayOfAttachments,
  reactions: arrayOfReactions,
  task,
});

export { comment, arrayOfComments };
